import {
  Center,
  Checkbox,
  HStack,
  Heading,
  Input,
  Radio,
  RadioGroup,
  Stack,
  Text,
  VStack,
} from "@chakra-ui/react";
import { FractionChildProps, FractionProps, PostFraction } from "../Fraction";
import { DisplayMode } from "../../Post";
import { aliasReplacement } from "../fractionHelpers";

export type HeadingFractionState = undefined | HeadingState;

interface HeadingState {
  text: string;
  center: boolean;
  size: string;
}

function HeadingEditorAndViewer(
  props: FractionChildProps<HeadingFractionState>
) {
  if (props.mode === DisplayMode.EDIT) {
    return <HeadingEditor {...props} />;
  } else {
    return <HeadingViewer {...props} />;
  }
}

function HeadingViewer(props: FractionChildProps<HeadingFractionState>) {
  const defaultText = "[Lägg till title]";

  const title = aliasReplacement(props.state?.text ?? defaultText, props.alias);

  if (props.state?.center) {
    return (
      <Center>
        <Heading
          size={props.state.size}
          marginTop={"25px"}
          marginBottom={"10px"}
        >
          {title}
        </Heading>
      </Center>
    );
  }
  return (
    <Heading
      size={props.state?.size ?? "xl"}
      marginTop={"25px"}
      marginBottom={"10px"}
    >
      {title}
    </Heading>
  );
}

function HeadingEditor(props: FractionChildProps<HeadingFractionState>) {
  return (
    <VStack>
      <HStack
        style={{
          margin: "20px",
          marginTop: "20px",
        }}
      >
        <Text>Title:</Text>
        <Input
          margin={"10px"}
          width="sm"
          textColor={"black"}
          placeholder="Example title"
          value={props.state?.text}
          onChange={(e) => {
            if (props.onChange !== undefined) {
              props.onChange({
                ...(props.state || { center: false, size: "xl" }),
                text: e.target.value,
              });
            }
          }}
        />
      </HStack>
      <HStack
        style={{
          margin: "20px",
          marginTop: "20px",
        }}
      >
        <Checkbox
          onChange={(e) => {
            if (props.onChange !== undefined) {
              props.onChange({
                ...(props.state || { text: "", size: "xl" }),
                center: e.target.checked,
              });
            }
          }}
          isChecked={props.state?.center}
        >
          Center text
        </Checkbox>
      </HStack>
      <HStack>
        <Text>Storlek: </Text>
        <RadioGroup
          onChange={(selection) => {
            if (props.onChange !== undefined) {
              props.onChange({
                ...(props.state || { text: "", size: "xl", center: false }),
                size: selection,
              });
            }
          }}
          value={props.state?.size ?? "xl"}
        >
          <Stack direction="row" textColor={"black"}>
            <Radio value={"lg"}>L</Radio>
            <Radio value={"xl"}>XL</Radio>
            <Radio value={"2xl"}>XXL</Radio>
          </Stack>
        </RadioGroup>
      </HStack>
    </VStack>
  );
}

export const HeadingFraction = (props: FractionProps<HeadingFractionState>) => {
  return (
    <PostFraction {...props}>
      <HeadingEditorAndViewer />
    </PostFraction>
  );
};
